import { FiDownload, FiSend } from "react-icons/fi";
import Reveal from "./Reveal";
import Button from "./Button";
import profile from "../_data/profile.json";
import { useCopy } from "../i18n/useCopy";

/**
 * Closing call to action: contact, Telegram and CV download.
 *
 * @component
 */

const CallToAction = ({ title }) => {
  const t = useCopy();
  const telegram = profile.socials.find((s) => s.name === "Telegram");

  return (
    <section className="ctaSection container" aria-labelledby="cta-title">
      <Reveal className="ctaBox">
        <h2 id="cta-title">{title || t.cta.title}</h2>
        <p>{t.cta.text}</p>
        <div className="ctaButtons">
          <Button name={t.cta.start} to="/contact" />
          {telegram && (
            <Button
              name={t.cta.telegram}
              href={telegram.url}
              variant="ghost"
              icon={<FiSend className="arrow-icon" aria-hidden="true" />}
            />
          )}
          <Button
            name={t.cta.cv}
            href={profile.cv.pdf}
            download
            variant="ghost"
            icon={<FiDownload className="arrow-icon" aria-hidden="true" />}
          />
        </div>
      </Reveal>
    </section>
  );
};

export default CallToAction;
